function getModalPresentationStyle(): 'transparentModal' {
    return 'transparentModal';
}

export default getModalPresentationStyle;
